import React from "react";
import FooterTwo from "../components/Footer/FooterTwo";
import FooterData from "../components/Footer/FooterData";
import CustomNavbar from "../components/CustomNavbar";
import Breadcrumb from "../components/Breadcrumb";

const Others = (props) => {

  let files = "";
  if (props.files?.length > 0) {
    files = (<div>
      <h6 className="f_p f_size_15 t_color3 f_500 mb_20">
        Please find attached :{" "}
      </h6>
      {props.files?.map((x) => (
        <div className="row my-5">
          <div>
            <a href={x.url} target="_blank" rel="noopener noreferrer" >
              <img
              alt = "Download PDF"
                className="p-3"
                src={require("../img/files/pdf_image.jpg")}
              />
            </a>
          </div>
          <div className="p-3 f_400">{x.description}</div>
        </div>
      ))}
    </div>
    )
  }

  return (
    <div className="body_wrapper">
      <CustomNavbar
        slogo="sticky_logo"
        mClass="menu_four"
        nClass="w_menu ml-auto mr-auto"
      />
      <Breadcrumb
        breadcrumbClass="breadcrumb_area"
        imgName="breadcrumb/banner_bg.png"
        Ptitle={props.title}
        Pdescription=""
      />
      <section className="contact_info_area sec_pad bg_color">
        <div className="container">
          <h6 className="f_p f_size_20 t_color3 f_500 mb_20">{props.title}</h6>
          <div className="row">
            <div className="col-sm-4 p-3">
              {props.images.map((x) => (
                <img className="p-3" alt="Product" src={x} />
              ))}
            </div>
            <div className="col-sm-8">
              <h6 className="f_p f_size_15 t_color3 f_500 mb_20">
                {props.title} :{" "}
              </h6>
              {props.paragraphs?.map((x) => (
                <p>{x}</p>
              ))}
              <ul>
                {props.description?.map((x) => (
                  <li>{x}</li>
                ))}
              </ul>
              {files}
            </div>
          </div>
        </div>
        <FooterTwo FooterData={FooterData} />
      </section>
    </div>
  );
};

export default Others;
